import React from 'react';

import { Alert as AntdAlert } from 'antd';

import { ConditionsReactivateGenreSimplifieDto } from 'lib_api/lib/api/gen/api';

interface ConditionReactivateGenreSimplifieProps {
  conditions?: ConditionsReactivateGenreSimplifieDto;
}

function ConditionReactivateGenreSimplifie({
  conditions,
}: ConditionReactivateGenreSimplifieProps): React.ReactElement {
  const isInvalid: boolean =
    (conditions?.genreSimplifieValid || conditions?.alreadyExist) ?? false;

  return (
    <>
      {isInvalid && (
        <AntdAlert
          type="warning"
          className="alertInvalid"
          message={
            <>
              {conditions?.genreSimplifieValid && (
                <p className="alertInvalid--txt">
                  Le genre simplifié est déjà valide.
                </p>
              )}
              {conditions?.alreadyExist && (
                <p className="alertInvalid--txt">
                  Le genre simplifié existe déjà.
                </p>
              )}
            </>
          }
        />
      )}
    </>
  );
}

export default ConditionReactivateGenreSimplifie;
